import {
  REQUEST_MAP_GPS_GAMMING_POSITIONS,
  RESPONSE_MAP_GPS_GAMMING_POSITIONS,
  REQUEST_MAP_GPS_GAMMING_POSITIONS_FAILURE,
  CLEAR_MAP_GPS_GAMMING_POSITIONS,
} from "../actions/mapGpsJammingPositionsActions";

import { states } from "./queriesStates";

const initialState = {
  mapGpsJamminDataState: states.NOT_REQUESTED,
  gpsJammingsCount: 0,
  gpsJammings: [],
  errors: null,
};

const mapGpsJammingsReducer = (state = initialState, action) => {
  switch (action.type) {
    case REQUEST_MAP_GPS_GAMMING_POSITIONS:
      return Object.assign({}, state, {
        mapGpsJamminDataState: states.REQUEST,
      });
    case RESPONSE_MAP_GPS_GAMMING_POSITIONS:
      const { gpsJammings, count } = action.payload;

      return Object.assign({}, state, {
        mapGpsJamminDataState: states.READY,
        gpsJammings: gpsJammings,
        gpsJammingsCou: count,
        errors: [],
      });
    case REQUEST_MAP_GPS_GAMMING_POSITIONS_FAILURE:
      return Object.assign({}, state, {
        mapGpsJamminDataState: states.FAILURE,
        errors: action.errors,
      });
    case CLEAR_MAP_GPS_GAMMING_POSITIONS:
      return Object.assign({}, state, initialState);
    default:
      return state;
  }
};

export default mapGpsJammingsReducer;
